module.exports = __webpack_public_path__ + "img/course-item-b.56319a4e.png";